.header {
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: var(--spacing-m);
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s);
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  background-color: white;
  border-left: 4px solid transparent;
  border-radius: 0.3rem;
  box-shadow:
    rgba(22, 31, 39, 0.42) 0 20px 40px -10px,
    rgba(19, 26, 32, 0.08) 0 10px 20px -15px;
}

.itemButton {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
  display: flex;
  font-family: var(--font-family-base);
  font-size: var(--font-size-normal);
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  text-align: left;
  width: 100%;
}

.itemButton:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

.itemUnread {
  border-left-color: var(--color-primary);
}

.itemUnread .itemButton {
  font-weight: 600;
}

.itemRead .itemButton {
  color: var(--color-text-muted);
}

.iconWrap {
  align-items: center;
  background-color: var(--color-muted);
  border-radius: 50%;
  color: var(--color-primary);
  display: flex;
  flex-shrink: 0;
  height: 40px;
  justify-content: center;
  width: 40px;
}

.itemRead .iconWrap {
  color: var(--color-text-muted);
}

.itemContent {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
  overflow-wrap: anywhere;
}

.itemType {
  color: var(--color-text);
}

.itemRead .itemType {
  color: var(--color-text-muted);
}

.itemDate {
  color: var(--color-text-muted);
  font-size: var(--font-size-small);
}

.unreadDot {
  background-color: var(--color-primary);
  border-radius: 50%;
  flex-shrink: 0;
  height: 10px;
  width: 10px;
}

.empty {
  color: var(--color-text-muted);
  margin-top: var(--spacing-m);
}

@media (prefers-reduced-motion: reduce) {
  .itemButton {
    transition: none;
  }
}
